const DATE_FORMATTER_DE = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: 'Europe/Berlin',
});

const toValidDate = (value) => {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateDE = (value, fallback = '') => {
  const date = toValidDate(value);
  return date ? DATE_FORMATTER_DE.format(date) : fallback;
};

export const toDateInputValue = (value) => {
  const date = toValidDate(value);
  if (!date) return '';

  const parts = Object.fromEntries(
    DATE_FORMATTER_DE
      .formatToParts(date)
      .filter(({ type }) => type !== 'literal')
      .map(({ type, value: partValue }) => [type, partValue])
  );

  return `${parts.year}-${parts.month}-${parts.day}`;
};
